import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  IPenaltyWaiver,
  IPenaltyWaiverFile,
  TPenaltyWaiverTutorAmountData,
} from '.';
import { APIDataProvider, ApiPaths, TApiResponse } from '../../../api';
import { IMeetingRequest } from '../MeetingRequestsSlice';

export type TCreatePenaltyWaiver = {
  zoomRequestId: string;
  reason: string;
  files?: IPenaltyWaiverFile[];
};

export type TGetPenaltyWaivers = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  startDate?: string;
  endDate?: string;
  studentId?: string;
  courseId?: string;
  includeTutorAmountData?: boolean;
};

export type TGetPenaltyWaiverById = {
  id: string;
};

const apiDataProvider = new APIDataProvider();

const getPenaltyWaiversModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  startDate,
  endDate,
  studentId,
  courseId,
  includeTutorAmountData,
}: TGetPenaltyWaivers) => {
  let path = `${ApiPaths.penaltyWaivers}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (startDate) {
    path += `&startDate=${startDate}`;
  }

  if (endDate) {
    path += `&endDate=${endDate}`;
  }

  if (studentId) {
    path += `&studentId=${studentId}`;
  }

  if (courseId) {
    path += `&courseId=${courseId}`;
  }

  if (includeTutorAmountData) {
    path += `&includeTutorAmountData=1`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<{
      offset: number;
      limit: number;
      totalDocs: number;
      docs: Array<IPenaltyWaiver>;
      tutorAmountData?: TPenaltyWaiverTutorAmountData;
    }>
  >(path);

  return response.data;
};

export const createPenaltyAppealRequest = createAsyncThunk(
  '/penalty-waiver/create',
  async (data: TCreatePenaltyWaiver) => {
    const response = await apiDataProvider.post<
      TApiResponse<{
        penaltyWaiver: IPenaltyWaiver;
        zoomMeetingRequest: IMeetingRequest;
      }>
    >(`${ApiPaths.penaltyWaivers}`, data);

    return response.data;
  }
);

export const getPenaltyWaiverById = createAsyncThunk(
  '/penalty-waiver/get-one',
  async ({ id }: TGetPenaltyWaiverById) => {
    const response = await apiDataProvider.get<TApiResponse<IPenaltyWaiver>>(
      `${ApiPaths.penaltyWaivers}/${id}`
    );

    return response.data;
  }
);

export const getPenaltyWaivers = createAsyncThunk(
  '/penalty-waiver/list',
  getPenaltyWaiversModule
);
